import { render, staticRenderFns } from "./BdLogin.vue?vue&type=template&id=a35e2b98&scoped=true&"
import script from "./BdLogin.vue?vue&type=script&lang=js&"
export * from "./BdLogin.vue?vue&type=script&lang=js&"
import style0 from "./BdLogin.vue?vue&type=style&index=0&id=a35e2b98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a35e2b98",
  null
  
)

export default component.exports